




























































import {
  ConferenceDetailRestControllerApi,
  DoctorPaymentRestControllerApi,
  Configuration,
  CreditCardInfo,
  GmoCardInfo,
} from '@/types/api-docs'
import Vue from 'vue'
import Loading from '@/components/Loading.vue'
import CreditCard from '@/components/CreditCard.vue'
import GmoPayment, { GetTokenParam } from '@/utils/gmoPayment'
import CreditCardForm from '@/components/CreditCardForm.vue'

const conferenceDetailApi = new ConferenceDetailRestControllerApi(
  new Configuration({ basePath: `${window.location.origin}` })
)

const doctorPaymentApi = new DoctorPaymentRestControllerApi(
  new Configuration({ basePath: `${window.location.origin}` })
)

export type DataType = {
  cardNumber: string
  expireMonth: string
  expireYear: string
  name: string
  cvv: string
  shopId: string
  use3ds: boolean
  gmoCardInfo?: GmoCardInfo
  paymentResult?: string
  saveCardResult?: string
  loading: boolean
}

export default Vue.extend({
  name: 'CreditCardAdd',
  components: { CreditCardForm, CreditCard, Loading },
  data(): DataType {
    return {
      cardNumber: '',
      expireMonth: '',
      expireYear: '',
      name: '',
      cvv: '',
      shopId: '',
      use3ds: false,
      gmoCardInfo: undefined,
      paymentResult: '',
      saveCardResult: '',
      loading: false,
    }
  },
  async mounted() {
    await this.fetchConferenceSettlementInfo()
    await this.fetchDefaultCard()
  },
  methods: {
    generateGetGmoTokenParam(): GetTokenParam {
      return {
        cardno: this.cardNumber,
        expire: `${this.expireYear}${this.expireMonth}`,
        securitycode: this.cvv,
        holdername: this.name,
      }
    },
    async doSaveCard(gmoToken: string): Promise<string> {
      const cardInfo: CreditCardInfo = {
        gmoToken: gmoToken,
        defaultCard: true,
      }
      if (this.gmoCardInfo) {
        cardInfo.gmoCardSeq = this.gmoCardInfo.gmoCardSeq
      }
      if (this.use3ds) {
        return await doctorPaymentApi
            .doCheckCard3ds(cardInfo)
            .then((response) => {
              if (this.use3ds) {
                let data = response.data
                let jsonData = JSON.stringify(data)
                let json = JSON.parse(jsonData)
                return Promise.resolve(json.url)
              } else {
                return Promise.resolve('登録が完了しました')
              }
            })
            .catch(() => {
              return Promise.reject('登録に失敗しました')
            })
      } else {
        return await doctorPaymentApi
            .doSaveCard(cardInfo)
            .then(() => {
              return Promise.resolve('登録が完了しました')
            })
            .catch(() => {
              return Promise.reject('登録に失敗しました')
            })
      }
    },
    async doGmoSaveCard(): Promise<void> {
      if (this.gmoCardInfo) {
        if (!confirm('登録済みカード情報を上書きします。よろしいですか？')) {
          return
        }
      }

      this.loading = true
      const gmoToken = await GmoPayment.getGmoToken(this.generateGetGmoTokenParam(), this.shopId)
        .then((token) => {
          return token
        })
        .catch((message) => {
          alert(message)
          return null
        })
      if (gmoToken === null) {
        this.loading = false
        return
      }
      await this.doSaveCard(gmoToken)
        .then((message) => {
          if (this.use3ds) {
            window.location.href = message
          } else {
            alert(message)
            this.$router.go(0)
          }
        })
        .catch((message) => {
          alert(message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    async doDeleteCard(gmoCardSeq: number): Promise<string> {
      const cardInfo: CreditCardInfo = {
        gmoCardSeq: gmoCardSeq,
      }
      return await doctorPaymentApi
        .doDeleteCard(cardInfo)
        .then(() => {
          return Promise.resolve('削除しました')
        })
        .catch(() => {
          return Promise.reject('削除に失敗しました')
        })
    },
    async doGmoDeleteCard(gmoCardSeq: number): Promise<void> {
      this.loading = true
      await this.doDeleteCard(gmoCardSeq)
        .then((message) => {
          alert(message)
          this.$router.go(0)
        })
        .catch((message) => {
          alert(message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    async fetchConferenceSettlementInfo() {
      const { data } = await conferenceDetailApi.fetchConferenceSettlementInfo()
      this.shopId = data.gmoShopId
      this.use3ds = data.use3ds
      this.paymentResult = data.paymentResult
      this.saveCardResult = data.saveCardResult
      if (this.saveCardResult !== undefined && this.saveCardResult.length > 0) {
        if (this.saveCardResult.indexOf('success') > -1) {
          alert('登録が完了しました')
        } else {
          alert('登録に失敗しました')
        }
      } else if (this.paymentResult !== undefined && this.paymentResult.length > 0) {
        if (this.paymentResult.indexOf('error') > -1) {
          alert('登録に失敗しました')
        }
      }
    },
    async fetchDefaultCard() {
      const { data } = await doctorPaymentApi.fetchDefaultCard()
      this.gmoCardInfo = data
    },
  },
})
